/* RS feature cards (sections/rs-feature-cards.liquid): background image effect while scrolling.
   <rs-scroll-bg data-effect="parallax|zoom-in|zoom-out" data-amount="…" data-mobile="true|false">
   sets --rs-fc-shift (parallax, px) and --rs-fc-scale (zoom) on itself from how far the section has
   travelled through the screen (0 = just below, 1 = just above). Runs only while the section is on
   screen; off with "reduce motion" and, if chosen, on mobile. */

if (!customElements.get('rs-scroll-bg')) {
  customElements.define(
    'rs-scroll-bg',
    class RsScrollBg extends HTMLElement {
      connectedCallback() {
        this.effect = this.dataset.effect;
        this.amount = parseFloat(this.dataset.amount) || 0;
        if (!this.effect || this.effect === 'none') return;

        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.mobile = window.matchMedia('(max-width: 749px)');
        this.ticking = false;
        this.visible = false;

        this.onScroll = this.onScroll.bind(this);
        this.onChange = this.onChange.bind(this);

        this.observer = new IntersectionObserver((entries) => {
          this.visible = entries[0].isIntersecting;
          if (this.visible) this.onScroll();
        });
        this.observer.observe(this);

        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll, { passive: true });
        this.reduceMotion.addEventListener('change', this.onChange);
        this.mobile.addEventListener('change', this.onChange);
        this.onChange();
      }

      disconnectedCallback() {
        if (!this.observer) return;
        this.observer.disconnect();
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
        this.reduceMotion.removeEventListener('change', this.onChange);
        this.mobile.removeEventListener('change', this.onChange);
      }

      onChange() {
        this.active = !this.reduceMotion.matches && !(this.mobile.matches && this.dataset.mobile === 'false');
        this.classList.toggle('is-active', this.active);
        if (!this.active) {
          this.style.removeProperty('--rs-fc-shift');
          this.style.removeProperty('--rs-fc-scale');
          return;
        }
        this.update();
      }

      onScroll() {
        if (!this.active || !this.visible || this.ticking) return;
        this.ticking = true;
        requestAnimationFrame(() => {
          this.ticking = false;
          this.update();
        });
      }

      update() {
        const rect = this.getBoundingClientRect();
        const viewport = window.innerHeight;
        const progress = Math.min(1, Math.max(0, (viewport - rect.top) / (viewport + rect.height)));

        if (this.effect === 'parallax') {
          // The image is taller than the section by `amount`% at the top and at the bottom and moves
          // across that extra space: slower than the page, so it looks further away.
          const shift = (progress - 0.5) * 2 * (this.amount / 100) * rect.height;
          this.style.setProperty('--rs-fc-shift', `${shift.toFixed(1)}px`);
        } else {
          const extra = this.amount / 100 - 1;
          const scale = this.effect === 'zoom-in' ? 1 + extra * progress : 1 + extra * (1 - progress);
          this.style.setProperty('--rs-fc-scale', scale.toFixed(4));
        }
      }
    }
  );
}
